import { loader } from 'graphql.macro'

export default function arDashboardQuery ({ dataLoaders, queryKey }) {
  const [,
    filters = {}
  ] = queryKey

  const arDashboardSchema = loader('./arDashboard.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(arDashboardSchema, { filters })
}
